import { AxiosResponse } from "axios";
import { KeyValueDefault } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { GetQuotePartTypesByDirectAssignCriteriaResponse } from "@/main/models/response";

export abstract class IPartTypeApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;

	abstract GetPartTypesBySupplierAndQuoteItem(
		guidSupplier: string,
		guidQuoteItem: string,
	): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;

	abstract getPartTypeByDirectAssignCriteria(
		guidClaim?: string,
		guidQuote?: string,
	): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;
	abstract getPartTypeByDirectAssignCriteriaCancelledParts(
		quoteGuids: string[],
	): Promise<AxiosResponse<Result<GetQuotePartTypesByDirectAssignCriteriaResponse[]>>>;
}
